import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

export { Component, Prop, Watch };
